{
  "seo": {
    "title": "My Progress",
    "description": "Track quiz progress and daily activity."
  },
  "fallbackName": "Explorer",
  "loading": "Loading progress…",
  "noChild": {
    "title": "Parent Dashboard",
    "subtitle": "Switch to the parent dashboard to manage family settings.",
    "cta": "Go to Parent Dashboard"
  },
  "hero": {
    "tag": "Your Progress",
    "titlePrefix": "Great job, ",
    "titleSuffix": "!",
    "subtitle": "Here’s how your quizzes and curiosity are growing."
  },
  "stats": {
    "questionsAnswered": "Questions Answered",
    "quizAccuracy": "Quiz Accuracy",
    "likes": "Likes",
    "bookmarks": "Bookmarks"
  },
  "quickActions": {
    "title": "Quick Actions ⚡",
    "explore": "Explore Questions",
    "quiz": "Take a Quiz",
    "topics": "Browse Topics"
  },
  "charts": {
    "dailyActivity": "Daily Activity",
    "weeklyQuizzes": "Quizzes This Week"
  },
  "favorites": {
    "title": "Favorite Topics",
    "exploreMore": "Explore more",
    "plays": "{count} plays",
    "empty": "No topic activity yet. Try a quiz to get started!"
  },
  "redirect": {
    "loading": "Loading your dashboard..."
  },
  "activePath": {
    "badge": "ACTIVE STUDY QUEST",
    "viewAll": "Explore All Paths",
    "continue": "Continue Quest",
    "start": "Start Path",
    "completed": "Quest Completed!",
    "stars": "Stars",
    "stepsProgress": "{completed} of {total} steps completed"
  }
}
